/**
 * @generated SignedSource<<b6a0fe8e2e9827dd4425171ceb8e6d30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewEmailWithConsents_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "AnswerEmailWithConsents",
  "abstractKey": null
};

node.hash = "dff92cb56a15afbda4f0efd144558c26";

module.exports = node;
